import "./App.css";

import { Route, Routes } from "react-router-dom";
import Steps from "./app/components/Steps";
import Policies from "./app/policies/Policies";
import Claims from "./app/claims/Claims";
import Auth from "./app/auth/app-auth/Auth";
import RenewalPayment from "./app/renewals/RenewalPayment";
import Mpesa from "./app/payments/payment-methods/mpesa/Mpesa";
import Visa from "./app/payments/payment-methods/visa/Visa";
import Confirmation from "./app/payments/confirmation/Confirmation";
import { useEffect, useMemo, useState } from "react";
import ListClaims from "./app/claims/list-claims/ListClaims";
import { MixpanelProvider } from "react-mixpanel-browser";
import { useDispatch } from "react-redux";
import { tenantHostActions } from "./app/store/TenantCreds";
import { CURRENCY_DEFAULTS } from "./app/shared/currency-formatter";
import Callback from "./app/components/payments/confirmation/Callback";
import { getTenantHost } from "./theme";
import { MTEK_TRAVEL_MODULE_ID, STANDARD_TRAVEL_MODULE_ID } from "./configs/module";
import { STANDARD_INSURANCE_DOMAIN_PREFIX } from "./app/enums/prefix";

const PROMO_STORAGE_KEY = "promoCode";
const MIXPANEL_CONFIG = { track_PageView: true };

function App() {
  const rememberMe = useMemo(() => JSON.parse(localStorage.getItem("rememberMe") ?? "false") === true, []);
  const loggedIn = useMemo(() => JSON.parse(localStorage.getItem("loggedIn") ?? "false") === true, []);
  const userLoggedIn = useMemo(() => JSON.parse(sessionStorage.getItem("loggedIn") ?? "false") === true, []);

  const dispatch = useDispatch();

  const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

  useEffect(() => {
    const domain = getTenantHost();
    
    if (domain) {
      const domainPrefix = domain.split(".")[0];
      const currency = CURRENCY_DEFAULTS[domainPrefix]
      switch (domainPrefix) {
        case STANDARD_INSURANCE_DOMAIN_PREFIX:
          dispatch(tenantHostActions.setTenantHost({ domain, currency, moduleId: STANDARD_TRAVEL_MODULE_ID, country: "Ethiopia" }));
          break;
        default:
          dispatch(tenantHostActions.setTenantHost({ domain, currency, moduleId: MTEK_TRAVEL_MODULE_ID, country: "Kenya" }));
          break;
      }
    }

    const promoCodeFromUrl = new URLSearchParams(window.location.search).get("promo");
    if (promoCodeFromUrl) {
      sessionStorage.setItem(PROMO_STORAGE_KEY, promoCodeFromUrl);
    }

    // Auth
    if (rememberMe && loggedIn) {
      const uid = localStorage.getItem("uid") ?? "";
      const accessToken = localStorage.getItem("SKEY") ?? "";
      const displayName = localStorage.getItem("userName") ?? "";
      const email = localStorage.getItem("email") ?? sessionStorage.getItem("email") ?? "";

      sessionStorage.setItem("uid", uid);
      sessionStorage.setItem("SKEY", accessToken);
      sessionStorage.setItem("email", email);
      sessionStorage.setItem("userName", displayName);
    }
  }, [rememberMe, loggedIn, userLoggedIn, dispatch]);

  return (
    <MixpanelProvider config={MIXPANEL_CONFIG} token={MIXPANEL_TOKEN}>
      <Routes>
        <Route path="/" element={<Steps />} />
        <Route path="/login" element={<Auth />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/claims" element={<Claims />} />
        <Route path="/list-claims" element={<ListClaims />} />
        <Route path="/payments/renewal" element={<RenewalPayment />} />
        <Route path="/payments/make/mpesa" element={<Mpesa />} />
        <Route path="/payments/make/visa" element={<Visa />} />
        <Route path="/payments/make/confirm" element={<Confirmation />} />
        <Route path="/payments/callback" element={<Callback />} />
        <Route path="*" element={<Steps />} />
      </Routes>
    </MixpanelProvider>
  );
}

export default App;